import React, { useContext } from "react";
import { Controller } from "react-hook-form";
import { useFormContext } from "react-hook-form";
import { PhotoPickerArray } from "../../../../components/Lending/components";
import * as Contexts from "../../../../contexts";
import { TBanquetForm } from "../../types";

export const Gallery = () => {
  const { language } = useContext(Contexts.LanguageContext);
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext<TBanquetForm>();
  const stringPhotos = watch("galleryOld");
  const filePhotos = watch("galleryNew");

  return (
    <>
      <Controller
        control={control}
        defaultValue={[]}
        name="gallery"
        render={({ onChange, value }) => (
          <PhotoPickerArray photos={value || []} setPhotos={onChange} />
        )}
      />
    </>
  );
};
